module.exports = __webpack_public_path__ + "img/img-nodata.svg";